





















































import Vue from 'vue'
import './AssetFolder.scss'
import Folder from '@/components/FileExplorer/FolderList/Folder/Folder.vue'
import { Drag, Drop } from 'vue-drag-drop'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

export default Vue.extend(Folder).extend({
  name: 'AssetFolder',
  computed: {
    canEditFolder (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.AssetGroups)
    },
    canDeleteFolder (): boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.AssetGroups)
    }
  },
  components: {
    Drop,
    Drag
  }
})
